export let props = ['value', 'host']
export let model = {
  previewImg: undefined,
  cropper: false // 是否正在编辑？
}
export let computed = {
  imgUrl () {
    this.previewImg = this.value
    return this.previewImg
  }
}
